module.exports = __webpack_public_path__ + "static/media/bg2.8aa2a7b5.jpg";